import React, { useState } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './FlipCard.css';

const FlipCard = ({ front, back, title, subtitle, date, location, animationDelay = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { ref, hasAnimated } = useScrollAnimation('animate-in', 0.1, '0px 0px -50px 0px', animationDelay);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div ref={ref} className={`experience-card ${hasAnimated ? 'animate-in' : ''} ${isExpanded ? 'expanded' : ''}`}>
      <div className="card-header" onClick={handleToggle}>
        <div className="card-header-content">
          <div className="card-title-section">
            <h3 className="card-title">{title}</h3>
            <p className="card-subtitle">{subtitle}</p>
          </div>
          <div className="card-meta">
            <span className="card-date">{date}</span>
            {location && <span className="card-location">{location}</span>}
          </div>
        </div>
        <div className="expand-indicator">
          <span className={`expand-arrow ${isExpanded ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
      </div>
      
      <div className="card-preview">
        <p>{front}</p>
      </div>
      
      <div className={`card-details ${isExpanded ? 'expanded' : ''}`} style={{ maxHeight: isExpanded ? '1000px' : '0' }}>
        <div className="details-content">
          {Array.isArray(back) ? (
            <div className="details-list">
              {back.map((item, index) => (
                <div key={index} className="detail-item">
                  <span className="detail-text">{item}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="details-text">
              <p>{back}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
